import { useSelector } from 'react-redux';
import argumentSelectors from '@/redux/selectors/argumentSelectors';
import ArgumentInput from './ArgumentInput';
import ArgumentInputArray from './ArgumentInputArray';
import ArgumentInputObject from './ArgumentInputObject';
import memoizeSelector from '@/redux/lib/memoizeSelector.js';

const componentsMap = {
  default: ArgumentInput,
  array: ArgumentInputArray,
  object: ArgumentInputObject,
  custom: ArgumentInput
};

const ArgumentInputRowValue = ({ disabled, definition, argument, dataSource, dataSourcePath, dataSavePath, index }) => {
  const argumentValueTypeIsLexical = useSelector(memoizeSelector(`argumentValueType-${argument?.key}`, (state) => argumentSelectors[dataSource].activeArguments()(state)?.[argument?.key]?.type === 'lexical'));

  const isRawObject = ['array', 'object'].includes(argument?.dataType) && argumentValueTypeIsLexical;
  const isCustomComponent = argument?.component;
  const componentType = isRawObject || isCustomComponent || !['array', 'object'].includes(argument?.dataType) ? 'default' : argument?.dataType;
  const Component = componentsMap[componentType];

  return <Component disabled={disabled} definition={definition} argument={argument} dataSource={dataSource} dataSourcePath={dataSourcePath} dataSavePath={dataSavePath} index={index} />;
};

export default ArgumentInputRowValue;
